import { transformAsCurrency, formatCurrencyAsTex3 } from '~/utils/functions';

import { DecomposicaoData } from '../types';

export const calculaTotalSaldoQtde = (
  data: DecomposicaoData[],
  field: 'per_custo_kit' | 'qtd_decomp' | 'val_custo_inicial',
): number => {
  const total = data.reduce(
    (acc: number, item: DecomposicaoData) => acc + item[field],
    0,
  );
  const totalFormated = formatCurrencyAsTex3(total);
  return transformAsCurrency(totalFormated);
};
